module.exports = __webpack_public_path__ + "img/20_134.278a52f2.png";